import React from "react";
import {
  Footer,
  Header,
  SubtitleContainer,
  TitleContainer,
} from "../../components";
import img1 from "../../assets/transparencia-salarial-1.jpg";
import img2 from "../../assets/transparencia-salarial-2.jpg";
import img3 from "../../assets/transparencia-salarial-3.png";
import img4 from "../../assets/transparencia-salarial-4.png";
import img5 from "../../assets/transparencia-salarial-5.png";
import img6 from "../../assets/transparencia-salarial-6.png";
import img7 from "../../assets/transparencia-salarial-7.png";
import img8 from "../../assets/transparencia-salarial-8.png";
import img9 from "../../assets/transparencia-salaria-pe-3-2026.jpg";
import img10 from "../../assets/transparencia-salaria-rn-3-2026.jpg";
import img11 from "../../assets/transparencia-salarial-pe-9-2026.png";
import img12 from "../../assets/transparencia-salarial-rn-9-2026.png";
import "./index.scss";

const SalaryDocument: React.FC = () => {
  return (
    <div>
      <Header active="Transparência Salarial" />
      <TitleContainer>Transparência Salarial</TitleContainer>
      <SubtitleContainer>
        Em cumprimento à Lei nº 14.611/2023 e à Portaria MTE nº 3.714, a
        CONSOLIS torna público, por meio de seus canais de comunicação oficiais,
        a republicação do Relatório de Transparência e Igualdade Salarial de
        Mulheres e Homens, elaborado pelo Ministério do Trabalho e Emprego
        (MTE).
        <br />
        <br />
        O documento foi produzido a partir de informações fornecidas pelo
        e-Social, RAIS Junho 2026 e Portal Emprega Brasil, Agosto 2026.
        <br />
        <br />
        Reforçamos nosso compromisso com a promoção da equidade e da
        transparência nas relações de trabalho.
        <span style={{ marginTop: 10, display: "block" }}>
          Data de Atualização:{" "}
          <span style={{ fontStyle: "italic" }}>30/09/2026</span>
        </span>
      </SubtitleContainer>

      <img
        src={img12}
        alt="Transparência Salarial 12"
        className="wage-transparency-image"
      />
      <span
        style={{
          marginTop: 10,
          display: "block",
          margin: "0 auto",
          width: "fit-content",
        }}>
        Data de Publicação:{" "}
        <span style={{ fontStyle: "italic" }}>Setembro 2026</span>
      </span>
      <hr />

      <img
        src={img11}
        alt="Transparência Salarial 11"
        className="wage-transparency-image"
      />
      <span
        style={{
          marginTop: 10,
          display: "block",
          margin: "0 auto",
          width: "fit-content",
        }}>
        Data de Publicação:{" "}
        <span style={{ fontStyle: "italic" }}>Setembro 2026</span>
      </span>
      <hr />

      <img
        src={img10}
        alt="Transparência Salarial 10"
        className="wage-transparency-image"
      />
      <span
        style={{
          marginTop: 10,
          display: "block",
          margin: "0 auto",
          width: "fit-content",
        }}>
        Data de Publicação:{" "}
        <span style={{ fontStyle: "italic" }}>Março 2026</span>
      </span>
      <hr />

      <img
        src={img9}
        alt="Transparência Salarial 9"
        className="wage-transparency-image"
      />
      <span
        style={{
          marginTop: 10,
          display: "block",
          margin: "0 auto",
          width: "fit-content",
        }}>
        Data de Publicação:{" "}
        <span style={{ fontStyle: "italic" }}>Março 2026</span>
      </span>

      <hr />

      <img
        src={img1}
        alt="Transparência Salarial 1"
        className="wage-transparency-image"
      />
      <span
        style={{
          marginTop: 10,
          display: "block",
          margin: "0 auto",
          width: "fit-content",
        }}>
        Data de Publicação:{" "}
        <span style={{ fontStyle: "italic" }}>Setembro 2025</span>
      </span>

      <hr />

      <img
        src={img2}
        alt="Transparência Salarial 2"
        className="wage-transparency-image"
      />
      <span
        style={{
          marginTop: 10,
          display: "block",
          margin: "0 auto",
          width: "fit-content",
        }}>
        Data de Publicação:{" "}
        <span style={{ fontStyle: "italic" }}>Setembro 2025</span>
      </span>
      <hr />
      <img
        src={img3}
        alt="Transparência Salarial Natal"
        className="wage-transparency-image"
      />
      <span
        style={{
          marginTop: 10,
          display: "block",
          margin: "0 auto",
          width: "fit-content",
        }}>
        Data de Publicação:{" "}
        <span style={{ fontStyle: "italic" }}>Março 2025</span>
      </span>
      <hr />
      <img
        src={img4}
        alt="Transparência Salarial Recife"
        className="wage-transparency-image"
      />
      <span
        style={{
          marginTop: 10,
          display: "block",
          margin: "0 auto",
          width: "fit-content",
        }}>
        Data de Publicação:{" "}
        <span style={{ fontStyle: "italic" }}>Março 2025</span>
      </span>
      <hr />
      <img
        src={img8}
        alt="Transparência Salarial Recife"
        className="wage-transparency-image"
      />
      <span
        style={{
          marginTop: 10,
          display: "block",
          margin: "0 auto",
          width: "fit-content",
        }}>
        Data de Publicação:{" "}
        <span style={{ fontStyle: "italic" }}>Setembro 2024</span>
      </span>
      <hr />
      <img
        src={img7}
        alt="Transparência Salarial Recife"
        className="wage-transparency-image"
      />
      <span
        style={{
          marginTop: 10,
          display: "block",
          margin: "0 auto",
          width: "fit-content",
        }}>
        Data de Publicação:{" "}
        <span style={{ fontStyle: "italic" }}>Setembro 2024</span>
      </span>
      <hr />
      <img
        src={img5}
        alt="Transparência Salarial Recife"
        className="wage-transparency-image"
      />
      <span
        style={{
          marginTop: 10,
          display: "block",
          margin: "0 auto",
          width: "fit-content",
        }}>
        Data de Publicação:{" "}
        <span style={{ fontStyle: "italic" }}>Abril 2024</span>
      </span>
      <hr />
      <img
        src={img6}
        alt="Transparência Salarial Recife"
        className="wage-transparency-image"
      />
      <span
        style={{
          marginTop: 10,
          display: "block",
          margin: "0 auto",
          width: "fit-content",
        }}>
        Data de Publicação:{" "}
        <span style={{ fontStyle: "italic" }}>Abril 2024</span>
      </span>
      <br />

      <Footer />
    </div>
  );
};

export default SalaryDocument;
